var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory } from "./element-factory";
import { SurveyPanel } from "./panel";
import { SurveyQuestion } from "./reactquestion";
var SurveyFlowPanel = /** @class */ (function (_super) {
    __extends(SurveyFlowPanel, _super);
    function SurveyFlowPanel(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyFlowPanel.prototype, "flowPanel", {
        get: function () {
            return this.panel;
        },
        enumerable: false,
        configurable: true
    });
    SurveyFlowPanel.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        if (!!this.flowPanel) {
            this.flowPanel.onCustomHtmlProducing = function () {
                return "";
            };
            this.flowPanel.onGetHtmlForQuestion = this.renderQuestion;
        }
    };
    SurveyFlowPanel.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        if (!!this.flowPanel) {
            this.flowPanel.onCustomHtmlProducing = null;
            this.flowPanel.onGetHtmlForQuestion = null;
        }
    };
    SurveyFlowPanel.prototype.getQuestion = function (name) {
        return this.flowPanel.getQuestionByName(name);
    };
    SurveyFlowPanel.prototype.renderQuestion = function (question) {
        return "<question>" + question.name + "</question>";
    };
    SurveyFlowPanel.prototype.renderRows = function () {
        var result = this.renderHtml();
        if (!!result) {
            return [result];
        }
        else {
            return [];
        }
    };
    SurveyFlowPanel.prototype.getNodeIndex = function () {
        return this.renderedIndex++;
    };
    SurveyFlowPanel.prototype.renderHtml = function () {
        if (!this.flowPanel)
            return null;
        var html = "<span>" + this.flowPanel.produceHtml() + "</span>";
        if (!DOMParser) {
            var htmlValue = { __html: html };
            return React.createElement("div", { dangerouslySetInnerHTML: htmlValue });
        }
        var doc = new DOMParser().parseFromString(html, "text/xml");
        this.renderedIndex = 0;
        return this.renderParentNode(doc);
    };
    SurveyFlowPanel.prototype.renderNodes = function (domNodes) {
        var nodes = [];
        for (var i = 0; i < domNodes.length; i++) {
            var node = this.renderNode(domNodes[i]);
            if (!!node) {
                nodes.push(node);
            }
        }
        return nodes;
    };
    SurveyFlowPanel.prototype.getStyle = function (nodeType) {
        var style = {};
        if (nodeType.toLowerCase() === "b") {
            style.fontWeight = "bold";
        }
        if (nodeType.toLowerCase() === "i") {
            style.fontStyle = "italic";
        }
        if (nodeType.toLowerCase() === "u") {
            style.textDecoration = "underline";
        }
        return style;
    };
    SurveyFlowPanel.prototype.renderParentNode = function (node) {
        var nodeType = node.nodeName.toLowerCase();
        var children = this.renderNodes(this.getChildDomNodes(node));
        if (nodeType === "div")
            return React.createElement("div", { key: this.getNodeIndex() }, children);
        return (React.createElement("span", { key: this.getNodeIndex(), style: this.getStyle(nodeType) }, children));
    };
    SurveyFlowPanel.prototype.renderNode = function (node) {
        if (!this.hasTextChildNodesOnly(node)) {
            return this.renderParentNode(node);
        }
        var nodeType = node.nodeName.toLowerCase();
        if (nodeType === "question") {
            var question = this.flowPanel.getQuestionByName(node.textContent);
            if (!question)
                return null;
            var questionBody = (React.createElement(SurveyQuestion, { key: question.name, element: question, creator: this.creator, css: this.css }));
            return React.createElement("span", { key: this.getNodeIndex() }, questionBody);
        }
        if (nodeType === "div") {
            return React.createElement("div", { key: this.getNodeIndex() }, node.textContent);
        }
        return (React.createElement("span", { key: this.getNodeIndex(), style: this.getStyle(nodeType) }, node.textContent));
    };
    SurveyFlowPanel.prototype.getChildDomNodes = function (node) {
        var domNodes = [];
        for (var i = 0; i < node.childNodes.length; i++) {
            domNodes.push(node.childNodes[i]);
        }
        return domNodes;
    };
    SurveyFlowPanel.prototype.hasTextChildNodesOnly = function (node) {
        var nodes = node.childNodes;
        for (var i = 0; i < nodes.length; i++) {
            if (nodes[i].nodeName.toLowerCase() !== "#text")
                return false;
        }
        return true;
    };
    SurveyFlowPanel.prototype.renderContent = function (style, rows) {
        return React.createElement("f-panel", { style: style }, rows);
    };
    return SurveyFlowPanel;
}(SurveyPanel));
export { SurveyFlowPanel };
ReactElementFactory.Instance.registerElement("flowpanel", function (props) {
    return React.createElement(SurveyFlowPanel, props);
});
